var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loan-step-page"}},[(_vm.isMoral)?[_c('ApplicantLoanDetailPM',{attrs:{"id":_vm.id}})]:[_c('ApplicantLoanDetail',{attrs:{"id":_vm.id}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }